import React, { useContext } from "react"
import { GameBoardContext } from "../../../../context/createContext"
import { ToggleMenuMobileContainer } from "../ElementsStyles"
import Menu from "./Menu"

export default function ToggleMenuMobile() {
  const { settings } = useContext(GameBoardContext)

  return (
    <ToggleMenuMobileContainer
      showSettings={
        settings.showSettings || settings.settingsSubpage === "Settings"
      }
    >
      <Menu
        showMenu={
          settings.showSettings || settings.settingsSubpage === "Settings"
        }
      />
    </ToggleMenuMobileContainer>
  )
}
